var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.i,class:{ WithLogo: _vm.showLogo },attrs:{"id":"Boot"}},[_vm._v(_vm._s(_vm.getLinesVisible()))])}
var staticRenderFns = []

export { render, staticRenderFns }